import {
  TEAMMEMBER,
  ADD_TEAMMEMBER,
  DELETE_TEAMMEMBER,
  EDIT_TEAMMEMBER,
  TEAMMEMBER_DETAIL,
} from "../actions/Actions";

const initalState = {
  listLoader: false,
  listCount: null,
  list: [],
  addLoader: false,
  deleteLoader: false,
  editLoader: false,
  detailLoader: false,
  detail: null,
};

export function teammemberReducer(state = initalState, action) {
  const { type, payload } = action;

  switch (type) {
    // GET
    case TEAMMEMBER.LOADING:
      return {
        ...state,
        listLoader: true,
      };
    case TEAMMEMBER.SUCCESS:
      return {
        ...state,
        listLoader: false,
        listCount: payload.total,
        list: payload.rows,
      };
    case TEAMMEMBER.ERROR:
      return {
        ...state,
        listLoader: false,
      };

    // GET
    case TEAMMEMBER_DETAIL.LOADING:
      return {
        ...state,
        detailLoader: true,
        detail: null,
      };
    case TEAMMEMBER_DETAIL.SUCCESS:
      return {
        ...state,
        detailLoader: false,
        detail: payload,
      };
    case TEAMMEMBER_DETAIL.ERROR:
      return {
        ...state,
        detailLoader: false,
      };

    //  ADD
    case ADD_TEAMMEMBER.LOADING:
      return {
        ...state,
        addLoader: true,
      };
    case ADD_TEAMMEMBER.SUCCESS:
      return {
        ...state,
        addLoader: false,
      };
    case ADD_TEAMMEMBER.ERROR:
      return {
        ...state,
        addLoader: false,
      };

    //EDIT
    case EDIT_TEAMMEMBER.LOADING:
      return {
        ...state,
        editLoader: true,
      };
    case EDIT_TEAMMEMBER.SUCCESS:
      return {
        ...state,
        editLoader: false,
      };
    case EDIT_TEAMMEMBER.ERROR:
      return {
        ...state,
        editLoader: false,
      };

    // DELETE
    case DELETE_TEAMMEMBER.LOADING:
      return {
        ...state,
        deleteLoader: true,
      };
    case DELETE_TEAMMEMBER.SUCCESS:
      return {
        ...state,
        deleteLoader: false,
      };
    case DELETE_TEAMMEMBER.ERROR:
      return {
        ...state,
        deleteLoader: false,
      };

    default:
      return state;
  }
}
